import { GET, POST, PUT, DELETE, PATCH } from "../axios/apiService";

export const getAllPhoneNumbers = async ({ query = "", options = {} }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/workspace-settings/telephony/phone-numbers`;
  return GET(query ? `${url}?${query}` : url, options);
};

// Get accessible phone numbers for current user

export const getAccessiblePhoneNumbers = async ({ query = "", options = {} }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/workspace-settings/telephony/phone-numbers`;
  return GET(query ? `${url}?${query}` : url, options);
};

// Get single phone number by ID

export const getPhoneNumberById = async ({ phoneNumberId, options = {} }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/workspace-settings/telephony/phone-numbers/${phoneNumberId}`;
  return GET(url, options);
};

// Update phone number settings

export const updatePhoneNumber = async ({ phoneNumberId, data, options = {} }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/workspace-settings/telephony/phone-numbers/${phoneNumberId}`;
  return PATCH(url, data, options);
};

// Delete phone number

export const deletePhoneNumber = async ({ phoneNumberId, workspaceId, options = {} }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/workspace-settings/telephony/phone-numbers/${phoneNumberId}`;
  return DELETE(url, options);
};

//Search available phone numbers for purchase

export const searchAvailablePhoneNumbers = async ({ queryParams = {}, options = {} }) => {
  const params = new URLSearchParams(queryParams).toString();
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/workspace-settings/telephony/phone-numbers/available${params ? `?${params}` : ""}`;
  return GET(url, options);
};

// Purchase a phone number

export const purchasePhoneNumber = async ({ data, options = {} }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/workspace-settings/telephony/phone-numbers/purchase`;
  return POST(url, data, options);
};

// Get users with telephony access

export const getTelephonyUsers = async ({ query = "", options = {} }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/workspace-settings/telephony/user-access`;
  const fullUrl = query ? `${url}?${query}` : url;
  return GET(fullUrl, options);
};

// Get users with telephony access

export const getTelephonyUsersSimple = async ({ options = {} }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/workspace-settings/telephony/user-access`;
  return GET(url, options);
};

// Get specific user's dialer details

export const getUserDialerDetails = async ({ userId, options = {} }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/workspace-settings/telephony/user-access/${userId}`;
  return GET(url, options);
};

// Setup dialer access for users

export const setupDialerAccess = async ({ users, options = {} }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/workspace-settings/telephony/user-access`;
  const requestData = { users: users };
  return POST(url, requestData, options);
};

//Update user recording settings

export const updateUserRecordingSettings = async ({ userId, data, options = {} }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/workspace-settings/telephony/user-access/${userId}`;
  return PATCH(url, data, options);
};

// Revoke user dialer access

export const revokeUserDialerAccess = async ({ data, options = {} }) => {
  const url = `${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/workspace-settings/telephony/remove-user-access`;
  return POST(url, data, options);
};

export const getMembers = async ({ query, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/members${query ? `?${query}` : ""}`;
  return GET(url, options);
};
